define('gameday-index-enums/enums/events/LoadEvents',{
	pageReady: "GameDayIndex::pageReady",
	componentReady: "GameDayIndex::componentReady",
	dateChanged: "GameDayIndex::dateChanged",
	gameChanged: "GameDayIndex::gameChanged",
	updateCalendar: "GameDayIndex::updateCalendar",
	updateAds: "GameDayIndex::updateAds",
	audioFeedsLoaded: "GameDayIndex::audioFeedsLoaded",
	noAudioFeedsAvailable: "GameDayIndex::noAudioFeedsAvailable"
});
